import React, { useEffect } from 'react';
import clsx from 'clsx';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import InputAdornment from '@material-ui/core/InputAdornment';
import FormControl from '@material-ui/core/FormControl';
import IconButton from '@material-ui/core/IconButton';
import Button from '@material-ui/core/Button';
import Container from '@material-ui/core/Container';
import FormHelperText from '@material-ui/core/FormHelperText';
import Backdrop from "@material-ui/core/Backdrop";
import CircularProgress from '@material-ui/core/CircularProgress';
import AccountCircle from '@material-ui/icons/AccountCircle';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import { green } from '@material-ui/core/colors';
import { authenticationService } from '../../apiAuthorization/authenticationService';
import { HttpService } from "../../apiAuthorization/httpService";

const useStyles = makeStyles(theme => ({
    margin: {
        margin: theme.spacing(1)
    },
    inputWidth: {
        width: '100%',
        maxWidth:'300px'
    }
    ,
    imgLogo:{
        maxWidth: '300px ',
        marginBottom: '-100px',
        marginTop: '-30px',
    },
    error: {
        color: 'red',
        textAlign: 'center'
    },
    hide: {
        display:'none'
    },
    wrapper: {
        margin: theme.spacing(1),
        position: 'relative'
    },
    buttonProgress: {
        color: green[500],
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -12,
        marginLeft: -12
    },
    styleButtonProgress: {
        background: 'linear-gradient(45deg, #eaf0f3 30%, #c7c8ca 90%) !important'
    },
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: "#fff",
        position: "absolute"
    }
}
));

const StyledButton = withStyles({
    root: {
        background: 'linear-gradient(45deg, #3399cc 30%, #3399cc 90%)',
        borderRadius: 3,
        border: 0,
        color: 'white',
        height: 48,
        padding: '0 30px',
        boxShadow: '0 3px 5px 2px rgba(255, 105, 135, .3)',
        maxWidth: '300px',
        width:'100%'
    },
    label: {
        textTransform: 'capitalize',
    }
})(Button);

export default function LoginFrom(lProps) {
    const classes = useStyles();

    const [values, setValues] = React.useState({
        username: '',
        password: '',
        weight: '',
        weightRange: '',
        showPassword: false,
    });

    const [error, setError] = React.useState(false);
    const [errorMessage, setErrorMessage] = React.useState('');
    const [loading, setLoading] = React.useState(false);
    const [backDrop, setBackDrop] = React.useState(true);
    const [oAuthEnabled, setOAuthEnabled] = React.useState(true);

    const handleChange = prop => event => {
        setValues({ ...values, [prop]: event.target.value });
    };

    const handleClickShowPassword = () => {
        setValues({ ...values, showPassword: !values.showPassword });
    };

    const handleMouseDownPassword = event => {
        event.preventDefault();
    };

    const buttonClassname = clsx({
        [classes.styleButtonProgress]: loading
    });

    const getAuthorizationUrl = () => {
        setError(true);
        setErrorMessage("Loading initial data, please wait...");
        HttpService.post("/Account/getAuthorizationUrl")
            .then(authorizer => {
                if (authorizer.OAuthEnabled) {
                    setErrorMessage("Redirecting to OMS site, please wait...");
                    window.location.href = authorizer.AuthorizationUrl;
                }
                else {
                    setBackDrop(false);
                    setError(false);
                    setErrorMessage("");
                    setOAuthEnabled(false);
                }
            },
            (err) => {
                setBackDrop(false);
                setError(true);
                setErrorMessage(err);
            });
    };

    useEffect(() => {
        var searchString = window.location.search.substring(1);
        var pos = searchString.indexOf("=");
        var code = searchString.substring(pos + 1);

        setBackDrop(true);
        if (code === "") {
            getAuthorizationUrl();
        }
        else {
            setError(true);
            setErrorMessage("Validating the user access, please wait...");
            authenticationService.login("", "", code)
                .then(user => {
                    setBackDrop(false);
                    const { from } = { from: { pathname: "/" } };
                    lProps.props.history.push(from);
                },
                    err => {
                        setBackDrop(false);
                        setError(true);
                        setErrorMessage(err);
                    }
                );
        }
        // eslint-disable-next-line
    }, []);

    const onSubmit = (event) => {
        event.preventDefault();
        if (values.username === "" || values.password === "")
            return;

        setLoading(true);
        authenticationService.login(values.username, values.password, "")
            .then(user => {
                    setLoading(false);
                    const { from } = { from: { pathname: "/" } };
                    lProps.props.history.push(from);
                },
                err => {
                    setLoading(false);
                    setError(true);
                    setErrorMessage(err);
                }
            );
    };

    return (
        <Container maxWidth="xs" className="login-body">
            <div className="login-header">
                <img className={classes.imgLogo} alt="logo" src={require('../../images/TeamLEAD.svg')} />
            </div>
            <div>
                <Backdrop className={classes.backdrop} id="loginBackdrop" open={backDrop}>
                    <CircularProgress color="inherit" />
                </Backdrop>
                <form onSubmit={onSubmit} autoComplete="off">
                    {!oAuthEnabled &&
                        <>
                            <FormControl className={`${classes.margin} ${classes.inputWidth}`}>
                                <InputLabel htmlFor="input-with-icon-adornment">Username</InputLabel>
                                <Input
                                    id="input-with-icon-adornment"
                                    value={values.username}
                                    onChange={handleChange('username')}
                                    endAdornment={
                                        <InputAdornment position="start">
                                            <AccountCircle />
                                        </InputAdornment>
                                    }
                                />
                            </FormControl>
                            <br />
                            <FormControl className={`${classes.margin} ${classes.inputWidth}`}>
                                <InputLabel htmlFor="standard-adornment-password">Password</InputLabel>
                                <Input
                                    id="standard-adornment-password"
                                    type={values.showPassword ? 'text' : 'password'}
                                    value={values.password}
                                    onChange={handleChange('password')}
                                    endAdornment={
                                        <InputAdornment position="end">
                                            <IconButton
                                                aria-label="toggle password visibility"
                                                onClick={handleClickShowPassword}
                                                onMouseDown={handleMouseDownPassword}
                                            >
                                                {values.showPassword ? <Visibility /> : <VisibilityOff />}
                                            </IconButton>
                                        </InputAdornment>
                                    }
                                />
                            </FormControl>
                            <div className={`${classes.wrapper} m-t-10`} style={{ paddingLeft: '10%', paddingRight: '10%' }}>
                                <StyledButton variant="contained" type="submit" disabled={loading} className={buttonClassname}>Sign in</StyledButton>
                                {loading && <CircularProgress size={24} className={classes.buttonProgress} />}
                            </div>
                        </>
                    }
                    <FormControl className={`${classes.margin} ${classes.inputWidth}`}>
                        <FormHelperText className={`${classes.error} ${error === false ? classes.hide : ''}`}>{errorMessage}</FormHelperText>
                    </FormControl>
                </form>
            </div>
            <div className="lead-info">
                <a href={process.env.PUBLIC_URL + "/SecurityDisclaimer"} className={classes.margin} target="_blank" rel="noopener noreferrer">Security Disclaimer</a>
                <a href={process.env.PUBLIC_URL + "/ReleaseNotes"} className={classes.margin} target="_blank" rel="noopener noreferrer">Release Notes</a>
            </div>
        </Container>
  );
}
